import { MapPin, Clock, Phone } from "lucide-react";
import { motion } from "framer-motion";

const PAVIA_IMG =
  "https://images.unsplash.com/photo-1761840113245-a5e10a1538d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxwYXZpYSUyMGNpdHklMjBpdGFseXxlbnwwfHx8fDE3ODM4MzI3MDR8MA&ixlib=rb-4.1.0&q=85";

const VIQUERIA_IMG =
  "https://images.unsplash.com/photo-1759691554837-be93ac47760b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjB3YWl0aW5nJTIwcm9vbSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODM4MzI3MDR8MA&ixlib=rb-4.1.0&q=85";

const sedi = [
  {
    id: "san-matteo",
    nome: "Fondazione IRCCS Policlinico San Matteo",
    citta: "Pavia",
    indirizzo: "Viale Camillo Golgi, 19 — 27100 Pavia (PV)",
    giorni: "Lun · Mar · Mer · Gio",
    orario: "Visita 16:00 — 18:00",
    orarioPrenotazioni: "Prenotazioni telefoniche 09:00 — 15:00",
    tel: "0382 501702 · 0382 503073",
    img: PAVIA_IMG,
    span: "md:col-span-8",
    aspect: "aspect-[16/10]",
  },
  {
    id: "viqueria",
    nome: "Studio Viqueria",
    citta: "Voghera",
    indirizzo: "Voghera (PV) — su appuntamento",
    giorni: "Su appuntamento",
    orario: "Visita 09:30 — 13:00 · data da concordare",
    orarioPrenotazioni: "Prenotazioni telefoniche 09:00 — 15:00",
    tel: "0383 212647",
    img: VIQUERIA_IMG,
    span: "md:col-span-4",
    aspect: "aspect-[4/5]",
  },
];

export default function Sedi() {
  return (
    <section
      id="sedi"
      data-testid="sedi-section"
      className="py-24 md:py-32 bg-[#F9F8F6]"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-16">
          <div className="lg:col-span-7">
            <p className="eyebrow">03 — Sedi</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight mt-6 text-[#1A1D1A]">
              Due luoghi di cura,{" "}
              <span className="italic text-[#8A6D56]">un solo</span> percorso.
            </h2>
          </div>
          <p className="lg:col-span-5 text-base text-[#5C635E] leading-relaxed">
            Ricevo su appuntamento presso la Fondazione IRCCS Policlinico San Matteo di
            Pavia e presso lo Studio Viqueria di Voghera.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {sedi.map((s, i) => (
            <motion.article
              key={s.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`sede-card-${s.id}`}
              className={`${s.span} bg-white border border-[#E5E1D8] rounded-2xl overflow-hidden flex flex-col`}
            >
              <div className={`${s.aspect} w-full overflow-hidden bg-[#EFECE7]`}>
                <img
                  src={s.img}
                  alt={s.nome}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
              <div className="p-8 flex-1 flex flex-col">
                <p className="eyebrow">{s.citta}</p>
                <h3 className="font-serif-display text-2xl md:text-3xl leading-tight mt-3 text-[#1A1D1A]">
                  {s.nome}
                </h3>

                <div className="mt-6 space-y-3 text-sm text-[#1A1D1A]/90 flex-1">
                  <div className="flex items-start gap-3">
                    <MapPin className="w-4 h-4 mt-0.5 text-[#8A6D56]" strokeWidth={1.5} />
                    <span>{s.indirizzo}</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <Clock className="w-4 h-4 mt-0.5 text-[#8A6D56]" strokeWidth={1.5} />
                    <div className="flex flex-col gap-1">
                      <span>
                        {s.giorni} — <span className="text-[#5C635E]">{s.orario}</span>
                      </span>
                      <span className="text-xs text-[#5C635E]">{s.orarioPrenotazioni}</span>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <Phone className="w-4 h-4 mt-0.5 text-[#8A6D56]" strokeWidth={1.5} />
                    <span>{s.tel}</span>
                  </div>
                </div>

                <a
                  href="#prenota"
                  data-testid={`sede-cta-${s.id}`}
                  className="mt-8 inline-flex self-start items-center gap-2 px-6 py-3 rounded-full border border-[#8A6D56] text-[#8A6D56] text-sm font-semibold hover:bg-[#8A6D56] hover:text-white transition-colors duration-200"
                >
                  Prenota in questa sede
                  <span aria-hidden>→</span>
                </a>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
